import {HttpClient, HttpParams} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {environment} from '../../environments/environment';
import {ErrorModel} from '../app.model';
import {ACTION_TYPES} from '../app.types';
import {notify} from '../notification/notfication.actions';
import {AppStore} from '../store/store';
import {TargetSystemModel} from '../target/target-system.model';
import {HttpClientUtils} from '../utils/http-client.utils';
import {HttpInteraction} from '../utils/http-interactions.utils';
import {
  DistributionAccountCreateRequestModel,
  DistributionAccountEditRequestModel,
  DistributionAccountModel
} from './distribution-account.model';

export interface DistributionAccountAction {
  type: string;
  targetSystems?: TargetSystemModel[];
  distributionAccount?: DistributionAccountModel;
  distributionAccounts?: DistributionAccountModel[];
  error?: ErrorModel;
}

@Injectable()
export class DistributionAccountService {

  constructor(public appStore: AppStore,
              private httpClientUtils: HttpClientUtils,
              private httpClient: HttpClient) {
  }

  /** NO BFF */
  fetchTargetSystemsWithDistributionAccounts() {
    const params = new HttpParams().set('embed', 'distributionAccounts');

    this.httpClientUtils.getForJson(`${environment.apiSegments}/targetSystems`, {params})
      .onSuccess((response: any) => {
        const systems = TargetSystemModel.fromList(response.data || response as TargetSystemModel[]);
        this.appStore.dispatch({
          type: ACTION_TYPES.TARGET_SYSTEM_LIST_GET,
          targetSystems: systems
        });
      })
      .onError((error) => {
        this.appStore.dispatch({
          type: ACTION_TYPES.DISTRIBUTION_ACCOUNT_ERROR,
          error: HttpInteraction.errorModel(error)
        });
      })
      .doIt();
  }

  getSystemsWithDistributionAccounts(): Observable<TargetSystemModel[]> {
    const params = new HttpParams().set('embed', 'distributionAccounts');

    return this.httpClient.get<TargetSystemModel[]>(`${environment.apiSegments}/targetSystems`, {params});
  }

  /** NO BFF */
  createDistributionAccount(newDistributionAccount: DistributionAccountCreateRequestModel) {
    this.httpClientUtils.post(`${environment.apiSegments}/accounts`, newDistributionAccount)
      .onSuccess((response: any) => {
        const createdDistributionAccount = DistributionAccountModel.from(response.data || response as DistributionAccountModel);
        notify(this.appStore, `Distribution Account with foreignAccountId ${createdDistributionAccount.foreignAccountId} created.`);
        this.appStore.dispatch({
          type: ACTION_TYPES.DISTRIBUTION_ACCOUNT_LIST_SET,
          distributionAccount: createdDistributionAccount
        });
      })
      .onError((error) => {
        this.appStore.dispatch({
          type: ACTION_TYPES.DISTRIBUTION_ACCOUNT_ERROR,
          error: HttpInteraction.errorModel(error)
        });
      })
      .doIt();
  }

  editDistributionAccount(id: number, distributionAccount: DistributionAccountEditRequestModel) {
    this.httpClientUtils.put(`${environment.apiSegments}/accounts/${id}`, distributionAccount)
      .onSuccess((response: any) => {
        const editedDistributionAccount = DistributionAccountModel.from(response.data || response as DistributionAccountModel);
        notify(this.appStore, `Distribution Account with foreignAccountId ${editedDistributionAccount.foreignAccountId} updated.`);
        this.appStore.dispatch({
          type: ACTION_TYPES.DISTRIBUTION_ACCOUNT_LIST_UPDATE,
          distributionAccount: editedDistributionAccount
        });
      })
      .onError((error) => {
        this.appStore.dispatch({
          type: ACTION_TYPES.DISTRIBUTION_ACCOUNT_ERROR,
          error: HttpInteraction.errorModel(error)
        });
      })
      .doIt();
  }

}
